import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { confirmable, createConfirmation } from "react-confirm";

const Confirmation = ({
  okLabel = "Yes",
  cancelLabel = "No",
  title = "Confirm",
  confirmation,
  show,
  proceed,
  enableEscape = true
}) => {
  return (
    <div className="static-modal">
      {/* <Modal
        animation={false}
        show={show}
        onHide={() => proceed(false)}
        backdrop={enableEscape ? true : "static"}
        keyboard={enableEscape}
      >
        <Modal.Header className="px-2">
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{confirmation}</Modal.Body>
        <Modal.Footer>
          <button className="cancel-btn" onClick={() => proceed(false)}>{cancelLabel}</button>
          <button
            className="custom-btn"
            bsStyle="primary"
            onClick={() => proceed(true)}
          >
            {okLabel}
          </button>
        </Modal.Footer>
      </Modal> */}
      <Modal
  animation={false}
  show={show}
  onHide={() => proceed(false)}
  backdrop={enableEscape ? true : "static"}
  keyboard={enableEscape}
  centered
  dialogClassName="modal-md"
>
  <div className="modal-content" style={{ borderRadius: '8px' }}>
    <div 
      className="modal-header" 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        padding: '12px 16px'
      }}
    >
      <p style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>{title}</p>
      <button 
        onClick={() => proceed(false)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#000',
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
          lineHeight: '1'
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
    <div className="modal-body p-3">
      {confirmation}
    </div>
    <div className="mt-2 mb-1" style={{
      padding: '2px 4px',
      display: 'flex',
      justifyContent: 'end',
    }}>
      <button
        type="button"
        className="cancel-btn-sm me-1"
        onClick={() => proceed(false)}
      >
        {cancelLabel}
      </button>
      <button
        type="button"
        className="custom-btn-sm"
        onClick={() => proceed(true)}
      >
        {okLabel}
      </button>
    </div>
  </div>
</Modal>
    </div>
  );
};

Confirmation.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func, // called when ok button is clicked.
  enableEscape: PropTypes.bool
};

export function confirm(
  confirmation,
  proceedLabel = "OK",
  cancelLabel = "No",
  options = {}
) {
  return createConfirmation(confirmable(Confirmation))({
    confirmation,
    proceedLabel,
    cancelLabel,
    ...options
  });
}
